import { ApiClient } from "./clients";
import { Template, ListService } from "@/types";

export const TemplateService: ListService<Template> = {
  async load(id: number) {
    const template = await ApiClient.get<Template>(`/api/v1/template/${id}/`, {
      all_data: "1",
    });
    return template
      ? { ...template, updated_at: template.created_at }
      : undefined;
  },
};
